// File: Clients.js
import api from "./Axios.js";

export async function searchClients(name = '') {
  const response = await api.get(`/clients`, {
    params: { name }
  });
  return response.data;
}